import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import {
    NavigationService,
    INavigationData,
    AuthService,
} from '../../service';
import { SubSink } from 'subsink';
import { CommonService } from '../../../../modules/common/service/common/common.service';
import { AirAppRoutes } from '../../../../modules/common/lib/air-api-constant';
import { UserControlService } from '../../../../modules/common/service/userControl/user-control.service';
import { EFeatures } from '../../../../modules/common/lib/model/common';
import { MenuItem } from 'primeng/api';
import { AppComponent } from '../../../../../app.component';
import { SubscriptionLike } from 'subsink/dist/subsink';

@Component({
    selector: 'app-menu-air',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppMenuComponent implements OnInit, OnDestroy {
    showAirDisplay: boolean = true;
    airListItems: MenuItem[] = []; // ✅ Ensure it's always initialized as an array

    currentRoute: string = "";
    selectedRoute: any = {};

    private subscription = new SubSink();

    constructor(
        public app: AppComponent,
        private navigationService: NavigationService,
        private authService: AuthService,
        private airUserControlService: UserControlService,
        private router: Router,
        private commonService: CommonService
    ) {
        this.subscription.add(
            this.commonService.showAirDisplay$.subscribe((showAir) => {
                this.showAirDisplay = showAir;
                this.populateMenuItems();
            })
        );

        this.subscription.add(
            this.navigationService.$currentNav.subscribe((selectedNav: INavigationData) => {
                if (selectedNav) {
                    this.currentRoute = selectedNav.route;
                }
            })
        );
    }

    reRouteSameUrl(ev: any) {
        this.commonService.updateSameRouteNavigation(false);
    }

    ngOnInit() {
        this.populateMenuItems();
    }

    populateMenuItems() {
        this.subscription.add(this.menuItems());
    }

    menuItems(): SubscriptionLike {
        return this.airMenuItems();
    }

    airMenuItems(): SubscriptionLike {
        return this.airUserControlService.$userFeatures.subscribe((features: any) => {
            const tMenues: MenuItem[] = [
                {
                    label: 'Home',
                    icon: 'fal fa-home',
                    routerLink: [this.commonService.getRoute({ route: AirAppRoutes.User.HOME, type: 'User' })],
                    command: (event) => this.reRouteSameUrl(event)
                },
                {
                    label: 'Tracking List',
                    icon: 'fal fa-route',
                    routerLink: [this.commonService.getRoute({ route: AirAppRoutes.User.TRACKING_LIST, type: 'User' })],
                } 
            ];

            if (features) {
                features.forEach((feature: any) => {
                    switch (feature.name) {
                        case EFeatures.EXCEPTION_MANAGEMENT:
                            tMenues.push({
                                label: 'Data Management',
                                icon: 'fal fa-database',
                                items: [
                                    {
                                        label: 'Exception Manager',
                                        icon: 'fal fa-exclamation',
                                        routerLink: [this.commonService.getRoute({ route: AirAppRoutes.Manager.EXCEPTION_ROUTE, type: 'Manager' })],
                                        disabled: true,
                                    },
                                    {
                                        label: 'Event Manager',
                                        icon: 'fal fa-calendar-plus',
                                        routerLink: [this.commonService.getRoute({ route: AirAppRoutes.Manager.EVENTS_ROUTE, type: 'Manager' })],
                                    },
                                ],
                            });
                            break;

                        case EFeatures.MASTER_DATA_MANAGER:
                            tMenues.push({
                                label: 'Master Data Manager',
                                icon: 'fal fa-users-cog',
                                items: [
                                    {
                                        label: 'Flight Equivalency Managemant',
                                        icon: 'fal fa-route',
                                        routerLink: [this.commonService.getRoute({ route: AirAppRoutes.User.FLIGHT_EQUIVALENCY_MANAGER, type: 'User' })],
                                    }
                                ],
                            });
                        // case EFeatures.ADMIN:
                        //     tMenues.push({
                        //         label: 'User Management',
                        //         icon: 'fal fa-users-cog',
                        //         routerLink: [this.commonService.getRoute({ route: AirAppRoutes.Manager.USER_CONTROL, type: 'Manager' })],
                        //     });
                        //     break;                        
                    }
                });
            }

            this.airListItems = [...tMenues]; // ✅ Assign correctly to trigger Angular change detection
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
